const initials = 'product/';
export const SET_CURRENT_PRODUCT_DETAIL = `${initials}SET_CURRENT_PRODUCT_DETAIL`;
export const REMOVE_CURRENT_PRODUCT_DETAIL = `${initials}REMOVE_CURRENT_PRODUCT_DETAIL`;
export const UPDATE_DISCOUNT = `${initials}UPDATE_DISCOUNT`;
export const GROSS_AMOUNT_UPDATE = `${initials}GROSS_AMOUNT_UPDATE`;
